export default "__VITE_ASSET__C391if12__"